import { render } from "./SetPricePartnerModal.vue?vue&type=template&id=0fee1636"
import script from "./SetPricePartnerModal.vue?vue&type=script&lang=js"
export * from "./SetPricePartnerModal.vue?vue&type=script&lang=js"

import "./SetPricePartnerModal.vue?vue&type=style&index=0&id=0fee1636&lang=css"
script.render = render

export default script